import addRoute from '@/router/add-route';

const GatewayAccounts = () => import('@/modules/gateway-accounts/gateway-accounts.vue');
const GatewayAccountsForm = () => import('@/modules/gateway-accounts/gateway-accounts-form.vue');
const GatewyAccountDetails = () => import('@/modules/gateway-accounts/gateway-account-details');

const gatewayAccounts = [
    addRoute({
        name: 'gateway-accounts',
        path: '/gateway-accounts',
        component: GatewayAccounts,
        root: {label: 'Settings', name: 'settings'},
    }),
    addRoute({
        name: 'add-gateway-account',
        path: '/gateway-accounts/add',
        component: GatewayAccountsForm,
        root: {label: 'Settings', name: 'settings'},
    }),
    addRoute({
        name: 'update-gateway-account',
        path: '/gateway-accounts/update/:id',
        component: GatewayAccountsForm,
        root: {label: 'Settings', name: 'settings'},
    }),
    addRoute({
        name: 'gateway-account-details',
        path: '/gateway-accounts/:id',
        component: GatewyAccountDetails,
        root: {label: 'Settings', name: 'settings'},
    }),
];

export default gatewayAccounts;
